<template>
  <dashboard />
</template>

<script>
export default {
  name: "DashboardPage",
  components: {
    dashboard: () => import("@/components/templates/Dashboard.vue"),
  },
};
</script>

<style></style>
